// extracted by mini-css-extract-plugin
module.exports = {"operationTitle":"operation-title___2JsiN","title":"title___2W3Tc"};